import { JSONContent, NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import { useCallback, useMemo } from 'react';

import { RecipientPopover } from '@bonusly/common-recipient-popover';
import { Recipient } from '@bonusly/recipient-entities';

import { useRichInputContext } from '../../hooks/use-rich-input-context';

type Node = { attrs: { id: string } };

export const RecipientComponent = (props: NodeViewProps) => {
	const { deleteNode, editor, node, getPos, extension } = props;

	const { parentComponent } = useRichInputContext();

	const { options } = extension;
	const { attrs } = node;
	const { id, record } = attrs;

	const recipient: Recipient = useMemo(() => record ?? {}, [record]);
	const isGroup = recipient.type === 'group';

	const onExpand = useCallback(
		(users: Recipient[]) => {
			const nodes: Node[] = editor.$node('paragraph')?.content.toJSON();

			const content = users.reduce((acc, user) => {
				// filter if already mentioned
				const mentioned = nodes?.find((node) => node.attrs?.id === user.username);
				if (mentioned) return acc;

				const recipient = { id: user.username, record: user };
				acc.push({ type: 'recipient', attrs: recipient });
				acc.push({ type: 'text', text: ' ' });
				return acc;
			}, [] as JSONContent[]);

			editor.chain().focus().insertContentAt(getPos(), content).run();
			window.getSelection()?.collapseToEnd();
			deleteNode();
		},
		[deleteNode, editor, getPos]
	);

	return (
		<NodeViewWrapper as="span" data-type="recipient" data-id={id} data-record={JSON.stringify(recipient)}>
			<RecipientPopover recipient={recipient} isDisabled={!isGroup} isExpandable={parentComponent !== 'announcement-modal'} onExpand={onExpand}>
				<span>
					{options.char}
					{id}
				</span>
			</RecipientPopover>
		</NodeViewWrapper>
	);
};
